import { useCollectionFilterQueryParamsContext } from '../../../../../../../brunswick/containers/CollectionFilterQueryParamsContext'

import { AppliedFilterLabels } from './AppliedFilterLabels/AppliedFilterLabels'
import { DesktopFilterNav } from './DesktopFilterNav'
import { Body } from './styles'

export const DesktopFilterBar = () => {
  const { clearAllFilters, selectedFilters, toggleSelectedFilter } =
    useCollectionFilterQueryParamsContext()

  return (
    <Body>
      <DesktopFilterNav />
      {Object.keys(selectedFilters).length !== 0 && (
        <AppliedFilterLabels
          clearAllFilters={clearAllFilters}
          selectedFilters={selectedFilters}
          toggleSelectedFilter={toggleSelectedFilter}
        />
      )}
    </Body>
  )
}
